import { render, staticRenderFns } from "./FormSummary.vue?vue&type=template&id=1675410a&scoped=true&"
import script from "./FormSummary.vue?vue&type=script&lang=ts&"
export * from "./FormSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1675410a",
  null
  
)

export default component.exports